var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 10H16C14.8954 10 14 10.8954 14 12V20C14 25.5228 18.4772 30 24 30C29.5228 30 34 25.5228 34 20V12C34 10.8954 33.1046 10 32 10ZM16 6C12.6863 6 10 8.68629 10 12V20C10 27.732 16.268 34 24 34C31.732 34 38 27.732 38 20V12C38 8.68629 35.3137 6 32 6H16Z",
    fill: "url(#paint0_linear_1215_4838)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 16C2 12.6863 4.68629 10 8 10H14V26H10C5.58172 26 2 22.4183 2 18V16ZM8 14H10V22C7.79086 22 6 20.2091 6 18V16C6 14.8954 6.89543 14 8 14Z",
    fill: "url(#paint1_linear_1215_4838)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 16C46 12.6863 43.3137 10 40 10H34V26H38C42.4183 26 46 22.4183 46 18V16ZM40 14H38V22C40.2091 22 42 20.2091 42 18V16C42 14.8954 41.1046 14 40 14Z",
    fill: "url(#paint2_linear_1215_4838)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30C22.8954 30 22 30.8954 22 32V38H18C16.8954 38 16 38.8954 16 40C16 41.1046 16.8954 42 18 42H30C31.1046 42 32 41.1046 32 40C32 38.8954 31.1046 38 30 38H26V32C26 30.8954 25.1046 30 24 30Z",
    fill: "url(#paint3_linear_1215_4838)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1215_4838",
    x1: 13.5538,
    y1: 8.36923,
    x2: 34.1231,
    y2: 31.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1215_4838",
    x1: 7.58462,
    y1: 11.3538,
    x2: 14.5775,
    y2: 32.6986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1215_4838",
    x1: 7.58462,
    y1: 11.3538,
    x2: 14.5775,
    y2: 32.6986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8951"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1215_4838",
    x1: 18.0308,
    y1: 31.0154,
    x2: 26.2542,
    y2: 43.1855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB8951"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.faa396911e2f95973d4d30f7dd9ff759.svg";
export { ForwardRef as ReactComponent };